import { HttpClient, HttpParams } from '@angular/common/http';
import { PriceBook } from '@jms/model';
import { Subject, BehaviorSubject } from 'rxjs';
import { ISearcher } from '../interfaces/search.interface';
import { EntitySearchParams } from './core.data.searcher';
import * as Enumerable from 'linq';
import { map, catchError, debounceTime, filter } from 'rxjs/operators';

export class PricebookSearcher implements ISearcher {
  protected _searchSubject = new Subject<EntitySearchParams>();
  public readonly data$ = new BehaviorSubject<PriceBook[]>([]);

  constructor(
    private http: HttpClient,
    private endPoint: string,
    private allowReturnAll = true,
    existing: any) {

    this._searchSubject
      .pipe(
        debounceTime(300),
        filter(query => {
          if (this.allowReturnAll) return true;
          return query ? true : false;
        })
      )
      .subscribe(query => {
        this.getData(query);
      });
  }

  public search(entityId?: string, query?: string) {
    this._searchSubject.next({ entityId: entityId, query: query });
  }

  public getResult() {
    return this.data$;
  }

  public getData(search: EntitySearchParams, existing: () => PriceBook[] = () => []) {

    const params = {};

    if (search.entityId) params['entityId'] = search.entityId;
    if (search.query) params['filter'] = search.query;

    this.http
      .get<PriceBook[]>(this.endPoint, { params: params })
      .pipe(
        map(books => {
          const data = Enumerable.from(books)
            .except(existing(), b => b.name)
            .toArray();

          this.data$.next(data);
        }),
        catchError(x => {
          return null;
        })
      )
      .subscribe();
  }
}

export class DefaultPricebookSearcher {
  protected _searchSubject = new Subject<string>();
  public readonly data$ = new BehaviorSubject<PriceBook>(undefined);

  constructor(
    private http: HttpClient,
    private endPoint: string) {

    this._searchSubject.subscribe(query => { this.getData(query); });
  }

  public searchDefaultPricebook(customerId: string) {
    this._searchSubject.next(customerId);
  }

  public getData(search: string) {
    if (search) {

      this.http
        .get<PriceBook>(this.endPoint + search)
        .pipe(
          map(pricebook => {
            this.data$.next(pricebook);
          }),
          catchError(x => {
            return null;
          })
        )
        .subscribe();

    } else {
      this.data$.next(null);
    }
  }
}
